var exports = {
  "i": "AltTextBadge.module__wrapper___Rkg3TU",
  "x": "AltTextBadge.module__button___Rkg3TU",
};

module.exports = exports;
